import keyMirror from 'keymirror';

const STOREFRONT_CODES = keyMirror({
  ar: null,
  br: null,
  ca: null,
  cl: null,
  cr: null,
  do: null,
  ec: null,
  es: null,
  eu: null,
  fr: null,
  gb: null,
  gt: null,
  hn: null,
  it: null,
  mx: null,
  ni: null,
  nl: null,
  pa: null,
  pe: null,
  sv: null,
  us: null,
  jp: null,
});

export default STOREFRONT_CODES;
